/* @flow */

import { type Usuario } from '../../../usuario/types';
import { type Endereco } from '../../../enderecos/types';
import formatarCpf from '../../../utils/formatar-cpf';
import formatarCep from '../../../utils/formatar-cep';
import hrefEmail from '../../../usuario/href-email';

export default (usuario: Usuario, endereco: Endereco) => `
<div class="detalhes" style="width: 500px;">
    <div class="col-md-6 perfil pull-left">
        <br><br>
        <img src="/img/user-icon.png" alt="Pessoa física" title="Pessoa física" width="80" height="80"/>
        <h3>${usuario.nome}</h3>
    </div>
    <div class="col-md-6 pull-right">
        <p>${usuario.nome}</p>
        ${usuario.cpf ? `<p title="${usuario.cpf}">${formatarCpf(usuario.cpf)}</p>` : ''}
        ${usuario.email ? `
            <p title="${usuario.email}">
                ${hrefEmail(usuario.email)}
            </p>
        ` : ''}
        <p>${formatarCep(endereco.cep)}</p>
        <p>${endereco.logradouro}, ${endereco.numero}</p>
        <p>${endereco.bairro}</p>
        <p>${endereco.cidade} - ${endereco.estado}</p>
    </div>
</div>
`;
